export default function convertToLTR(text) {
    return text;
}
